// Partner capability verification — platform staff verify/suspend the regulated capabilities a
// partner organization performs (employee lending, insurance, payroll disbursement, …). Every
// action is audited server-side. Backed by credit-service /api/v1/credit/admin/partners/*.
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);

export interface PartnerCapability {
  partner_id: string;
  partner_name: string;
  capability: string;
  status: 'pending' | 'verified' | 'suspended' | string;
  countries: string[];
  licence_refs?: unknown;
  verified_by?: string;
  verified_at?: string;
  created_at: string;
}

export const getPartnerCapabilities = async (status?: string): Promise<PartnerCapability[]> => {
  const r = await axios.get<{ capabilities: PartnerCapability[] }>(
    `${API_V1}/credit/admin/partners/capabilities`,
    { params: status ? { status } : {} },
  );
  return r.data.capabilities ?? [];
};

export const verifyCapability = (partnerId: string, capability: string) =>
  axios
    .post(`${API_V1}/credit/admin/partners/${partnerId}/capabilities/${encodeURIComponent(capability)}/verify`)
    .then((r) => r.data);

export const suspendCapability = (partnerId: string, capability: string) =>
  axios
    .post(`${API_V1}/credit/admin/partners/${partnerId}/capabilities/${encodeURIComponent(capability)}/suspend`)
    .then((r) => r.data);
